export default [
    {
        title: 'News',
        icon: { icon: 'tabler-news' },
        permissionIds: [31, 33],
        children: [
            { title: 'QL rss', to: { name: 'news-rss', meta: { permissionId: 31 } } },
            { title: 'Flash news', to: { name: 'news-flash-news', meta: { permissionId: 33 } } },
        ],
    },
]
